<script>
import Layout from '../../layouts/main'
import PageHeader from '../../components/page-header'
import AddCustomer from './add-customer';

export default {
  components: {Layout, PageHeader, AddCustomer},
  data() {
    return {};
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between icon-main-page" >
          <div class="page-title-left avatar-main-icon">
            <div class="avatar-xs mr-3">
              <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                <i class="bx bx-map-alt"></i>
              </span>
            </div>
             <div class="report-tag">
              <h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Add Customer') }}</h4>
              <p><router-link :to="{ name: 'customer-list'}">{{ trans.get('__JSON__.Customers') }}</router-link> > {{ trans.get('__JSON__.Add Customer') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <add-customer />
      </div>      
    </div>
  </Layout>
</template>